module.exports = __webpack_public_path__ + "assets/img/travel-day24.1504c6dc.png";